(function() {

    const $radioButtonGroups =  document.querySelectorAll('.radio-group')
    $radioButtonGroups.forEach(async $r => {
        const {default:Form} = await import(/* webpackChunkName: "formTogglers" */'./Form')
        new Form.RadioGrp($r)
    })

    const $checkboxGroups =  document.querySelectorAll('.checkbox-group')
    $checkboxGroups.forEach(async $c => {
        const {default:Form} = await import(/* webpackChunkName: "formTogglers" */'./Form')
        new Form.CheckboxGrp($c)
    })

    const materialGroups = document.querySelectorAll('.material-form')
    materialGroups.forEach(async ($grp) => {
        const {MaterialInput} = await import(/* webpackChunkName: "formMaterialInput" */'./MaterialInput')
        new MaterialInput($grp)
    })
})()